(function () {
  'use strict';

  var ALLOWED_GROUPS = ['Conjunto 01', 'Conjunto 02', 'Conjunto 03', 'Conjunto 04', 'Conjunto 05', 'Conjunto 06', 'Conjunto 07'];
  var ALLOWED_SIZES = ['M (9-14kg)', 'G (13-18kg)'];
  var EXPECTED_PRICE = 23790;
  var EXPECTED_COMPARE_AT = 44990;
  var EBOOK_VARIANT_ID = 42716340813870;

  function ensureUprightTitleStyles(scope) {
    if (!scope || !scope.querySelector || !scope.querySelector('[data-dryskip-bundle]')) return;
    document.documentElement.classList.add('dryskip-upright-titles');
    if (document.getElementById('dryskip-upright-title-style')) return;
    var style = document.createElement('style');
    style.id = 'dryskip-upright-title-style';
    style.textContent = [
      'html.dryskip-upright-titles h1,html.dryskip-upright-titles h2,html.dryskip-upright-titles h3,html.dryskip-upright-titles h4,html.dryskip-upright-titles h5,html.dryskip-upright-titles h6,html.dryskip-upright-titles [role="heading"]{font-family:Gluten,sans-serif!important;font-style:normal!important;font-variation-settings:"slnt" 0!important;font-synthesis-style:none!important;transform:none!important;}',
      'html.dryskip-upright-titles h1 strong,html.dryskip-upright-titles h2 strong,html.dryskip-upright-titles h3 strong,html.dryskip-upright-titles h4 strong,html.dryskip-upright-titles h5 strong,html.dryskip-upright-titles h6 strong,html.dryskip-upright-titles h1 b,html.dryskip-upright-titles h2 b,html.dryskip-upright-titles h3 b,html.dryskip-upright-titles h4 b,html.dryskip-upright-titles h5 b,html.dryskip-upright-titles h6 b,html.dryskip-upright-titles h1 em,html.dryskip-upright-titles h2 em,html.dryskip-upright-titles h3 em,html.dryskip-upright-titles h4 em,html.dryskip-upright-titles h5 em,html.dryskip-upright-titles h6 em,html.dryskip-upright-titles h1 i,html.dryskip-upright-titles h2 i,html.dryskip-upright-titles h3 i,html.dryskip-upright-titles h4 i,html.dryskip-upright-titles h5 i,html.dryskip-upright-titles h6 i{font-family:inherit!important;font-style:normal!important;font-variation-settings:"slnt" 0!important;font-synthesis-style:none!important;transform:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureCartStyles() {
    if (document.getElementById('dryskip-cart-style')) return;
    var style = document.createElement('style');
    style.id = 'dryskip-cart-style';
    style.textContent = [
      'cart-drawer .drawer__header{position:relative!important;justify-content:center!important;}',
      '#CartDrawer .drawer__heading{box-sizing:border-box;width:100%;margin:0;text-align:center!important;padding-inline:48px!important;font-family:var(--font-body-family,Arial,sans-serif)!important;font-style:normal!important;font-size:22px!important;font-weight:700!important;line-height:1.2!important;letter-spacing:0!important;text-transform:none!important;white-space:nowrap!important;}',
      '#CartDrawer .drawer__close{position:absolute!important;right:12px;top:50%;transform:translateY(-50%);}',
      'cart-drawer .button,#CartDrawer .quantity__button{--color-button:185,220,245!important;--color-button-text:31,41,51!important;background:#b9dcf5!important;background-color:#b9dcf5!important;color:#1f2933!important;border-color:#b9dcf5!important;}',
      '#CartDrawer .quantity__button svg{color:#1f2933!important;fill:currentColor!important;}',
      'cart-drawer .payment-badges-block{display:none!important;}',
      'cart-drawer [data-dryskip-yampi-error]{margin:8px 0 0;color:#9b1c1c;font-size:13px;line-height:1.35;text-align:center;}',
      '#CartDrawer .dryskip-linked-ebook{padding:10px!important;border:1px solid #decdf0!important;border-radius:14px!important;background:#f7f1fc!important;}',
      '#CartDrawer .dryskip-linked-ebook .cart-item__quantity,#CartDrawer .dryskip-linked-ebook cart-remove-button{display:none!important;}',
      '#CartDrawer .dryskip-free-ebook-badge{display:inline-flex;align-items:center;min-height:24px;margin-top:6px;padding:3px 9px;border-radius:999px;background:#6d388b;color:#fff;font-size:11px;font-weight:800;line-height:1;letter-spacing:.04em;text-transform:uppercase;}',
      '[data-dryskip-sticky-purchase][hidden]{display:none!important;}',
      '[data-dryskip-sticky-purchase]{box-sizing:border-box;position:fixed;z-index:8;left:50%;bottom:max(12px,env(safe-area-inset-bottom));width:min(calc(100% - 24px),560px);transform:translateX(-50%);padding:8px;border:1px solid rgba(31,41,51,.12);border-radius:16px;background:rgba(255,255,255,.96);box-shadow:0 10px 32px rgba(31,41,51,.22);backdrop-filter:blur(10px);}',
      '[data-dryskip-sticky-purchase] button{display:flex;width:100%;min-height:56px;align-items:center;justify-content:center;border:0;border-radius:12px;padding:12px 22px;background:#b9dcf5;color:#1f2933;font:800 17px/1.2 var(--font-body-family,Arial,sans-serif);letter-spacing:.01em;cursor:pointer;}',
      '[data-dryskip-sticky-purchase] button:focus-visible{outline:3px solid #1f2933;outline-offset:3px;}',
      '@media (min-width:750px){[data-dryskip-sticky-purchase]{bottom:20px;width:min(calc(100% - 40px),520px);padding:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  /* dryskip-cart-polish-v2 */
  function cartDrawerCheckoutError(drawer, button, originalLabel, message) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = originalLabel;
    button.dataset.dryskipYampiLoading = 'false';
    var error = drawer.querySelector('[data-dryskip-yampi-error]');
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-dryskip-yampi-error', '');
      error.setAttribute('role', 'alert');
      button.insertAdjacentElement('afterend', error);
    }
    error.textContent = message;
  }

  function validateCheckoutCart(cartPayload) {
    var items = cartPayload && Array.isArray(cartPayload.items) ? cartPayload.items : [];
    if (!items.length || Number(cartPayload.total_price || 0) <= 0) return 'Seu kit não está completo. Volte à página e adicione o DrySkip novamente.';
    var hasPaidItem = items.some(function (item) {
      return Number(item.final_line_price || item.line_price || 0) > 0;
    });
    return hasPaidItem ? '' : 'Seu kit não está completo. Volte à página e adicione o DrySkip novamente.';
  }

  function openCartDrawerYampi(drawer, button) {
    if (button.dataset.dryskipYampiLoading === 'true') return;
    var originalLabel = button.textContent.trim() || 'Finalizar a compra';
    var existingError = drawer.querySelector('[data-dryskip-yampi-error]');
    if (existingError) existingError.textContent = '';
    button.dataset.dryskipYampiLoading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'ABRINDO CHECKOUT...';
    if (typeof window.getAjax !== 'function' || typeof window.postAjax !== 'function') {
      window.location.assign('/cart?ref=yampi_buy_button');
      return;
    }
    var finished = false;
    var timeout = window.setTimeout(function () {
      if (finished) return;
      finished = true;
      cartDrawerCheckoutError(drawer, button, originalLabel, 'O checkout demorou para responder. Tente novamente.');
    }, 15000);
    window.getAjax('/cart.json?dryskip_checkout=' + Date.now(), function (cartResponse) {
      if (finished) return;
      var cartPayload;
      try { cartPayload = JSON.parse(cartResponse); }
      catch (_cartError) {
        finished = true;
        window.clearTimeout(timeout);
        cartDrawerCheckoutError(drawer, button, originalLabel, 'Não foi possível preparar o checkout. Tente novamente.');
        return;
      }
      cartPayload.items = Array.isArray(cartPayload.items) ? cartPayload.items.filter(function (item) {
        return String(item.variant_id || item.id) !== String(EBOOK_VARIANT_ID);
      }) : [];
      cartPayload.item_count = cartPayload.items.reduce(function (count, item) { return count + Number(item.quantity || 0); }, 0);
      var validationError = validateCheckoutCart(cartPayload);
      if (validationError) {
        finished = true;
        window.clearTimeout(timeout);
        cartDrawerCheckoutError(drawer, button, originalLabel, validationError);
        return;
      }
      var endpoint = window.cartEndpoint || 'https://api.dooki.com.br/v2/public/shopify/cart';
      window.postAjax(endpoint, JSON.stringify({ shop: window.location.host, cart_payload: cartPayload }), function (checkoutResponse) {
        if (finished) return;
        var checkout;
        try { checkout = JSON.parse(checkoutResponse); }
        catch (_checkoutError) { checkout = null; }
        if (!checkout || !checkout.active || !checkout.checkout_direct_url) {
          finished = true;
          window.clearTimeout(timeout);
          cartDrawerCheckoutError(drawer, button, originalLabel, 'Não foi possível abrir o checkout. Tente novamente.');
          return;
        }
        finished = true;
        window.clearTimeout(timeout);
        var target = typeof window.ymp_getUrlWithUtms === 'function' ? window.ymp_getUrlWithUtms(checkout.checkout_direct_url) : checkout.checkout_direct_url;
        window.location.assign(target);
      });
    }, function () {
      if (finished) return;
      finished = true;
      window.clearTimeout(timeout);
      cartDrawerCheckoutError(drawer, button, originalLabel, 'Não foi possível ler o carrinho. Tente novamente.');
    });
  }

  function bindCartDrawerYampi(drawer) {
    if (!drawer) return;
    var button = drawer.querySelector('#CartDrawer-Checkout, [name="checkout"]');
    if (!button || button.dataset.dryskipYampiBound === 'true') return;
    button.dataset.dryskipYampiBound = 'true';
    button.setAttribute('type', 'button');
    button.removeAttribute('name');
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCartDrawerYampi(drawer, button);
    }, true);
  }

  function bundleToken() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return 'dryskip-' + crypto.randomUUID();
    return 'dryskip-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  async function removeLegacyEbookLines(drawer) {
    if (!drawer || drawer.dataset.dryskipEbookCleanup === 'true') return false;
    drawer.dataset.dryskipEbookCleanup = 'true';
    try {
      var cartResponse = await fetch('/cart.js?dryskip_cleanup=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      var cartState = await cartResponse.json();
      if (!cartResponse.ok || !Array.isArray(cartState.items)) return false;
      var updates = {};
      cartState.items.forEach(function (item) {
        if (String(item.variant_id || item.id) === String(EBOOK_VARIANT_ID)) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return false;
      var payload = { updates: updates };
      if (typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
      }
      var response = await fetch(window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      var result = await response.json();
      if (!response.ok || result.status) return false;
      if (typeof drawer.renderContents === 'function' && result.sections) {
        drawer.renderContents(result);
        setTimeout(localizeCartDrawer, 0);
      }
      return true;
    } catch (_cleanupError) {
      return false;
    } finally {
      drawer.dataset.dryskipEbookCleanup = 'false';
    }
  }

  async function removeLinkedBundle(drawer, token, button) {
    if (!drawer || !token || drawer.dataset.dryskipBundleRemoving === 'true') return;
    drawer.dataset.dryskipBundleRemoving = 'true';
    if (button) button.disabled = true;
    try {
      var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js';
      var cartResponse = await fetch(cartUrl, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      var cartState = await cartResponse.json();
      if (!cartResponse.ok || !Array.isArray(cartState.items)) throw new Error('Não foi possível ler o carrinho.');
      var updates = {};
      cartState.items.forEach(function (item) {
        if (item.properties && item.properties._bundle_token === token) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      var payload = { updates: updates };
      if (typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
      }
      var updateUrl = window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
      var updateResponse = await fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      var result = await updateResponse.json();
      if (!updateResponse.ok || result.status) throw new Error(result.description || result.message || 'Não foi possível remover o kit.');
      if (typeof drawer.renderContents === 'function' && result.sections) {
        drawer.renderContents(result);
        setTimeout(localizeCartDrawer, 0);
      } else {
        window.location.assign(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');
      }
    } catch (removeError) {
      var message = removeError && removeError.message ? removeError.message : 'Não foi possível remover o kit. Tente novamente.';
      var error = drawer.querySelector('#CartDrawer-CartErrors');
      if (error) error.textContent = message;
      if (button) button.disabled = false;
    } finally {
      drawer.dataset.dryskipBundleRemoving = 'false';
    }
  }

  function bindLinkedBundleRemoval(drawer) {
    if (!drawer || drawer.dataset.dryskipBundleRemovalBound === 'true') return;
    drawer.dataset.dryskipBundleRemovalBound = 'true';
    drawer.addEventListener('click', function (event) {
      var button = event.target.closest('cart-remove-button button');
      var row = button && button.closest('[data-dryskip-bundle-role="parent"][data-dryskip-bundle-token]');
      if (!button || !row) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      removeLinkedBundle(drawer, row.dataset.dryskipBundleToken, button);
    }, true);
  }

  function localizeCartDrawer() {
    if (typeof document === 'undefined') return;
    ensureCartStyles();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    bindCartDrawerYampi(drawer);
    bindLinkedBundleRemoval(drawer);
    var heading = drawer.querySelector('.drawer__heading');
    if (heading) {
      var match = (heading.textContent || '').match(/\d+/);
      var renderedCount = drawer.querySelectorAll('#CartDrawer .cart-item').length;
      var count = renderedCount || (match ? parseInt(match[0], 10) : 0);
      var title = 'Carrinho • ' + count + (count === 1 ? ' produto' : ' produtos');
      if (heading.textContent.trim() !== title) heading.textContent = title;
    }
    var replacements = [
      ['Stock faible: Ces produits sont réservés pendant', 'Estoque baixo: estes produtos ficam reservados por'],
      ['Remises', 'Descontos'],
      ['Sous-total', 'Subtotal'],
      ['Vous économisez', 'Você economiza']
    ];
    var walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      replacements.forEach(function (pair) { value = value.replace(pair[0], pair[1]); });
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }

  function watchCartDrawer() {
    localizeCartDrawer();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.dryskipLocalizationWatch === 'true') return;
    drawer.dataset.dryskipLocalizationWatch = 'true';
    new MutationObserver(function () { setTimeout(localizeCartDrawer, 0); }).observe(drawer, { childList: true, subtree: true });
    removeLegacyEbookLines(drawer);
  }

  function resolveVariant(variants, group, size) {
    if (!ALLOWED_GROUPS.includes(group) || !ALLOWED_SIZES.includes(size)) return null;
    return variants.find(function (variant) {
      return variant.group === group && variant.size === size && variant.available === true &&
        variant.price === EXPECTED_PRICE && variant.compareAtPrice === EXPECTED_COMPARE_AT;
    }) || null;
  }

  function validMatrix(variants) {
    if (!Array.isArray(variants) || variants.length !== 14) return false;
    var keys = new Set();
    var ids = new Set();
    var groupMedia = new Map();
    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      if (!ALLOWED_GROUPS.includes(variant.group) || !ALLOWED_SIZES.includes(variant.size)) return false;
      if ((typeof variant.id !== 'number' && typeof variant.id !== 'string') || !String(variant.id)) return false;
      if (typeof variant.available !== 'boolean' || variant.price !== EXPECTED_PRICE || variant.compareAtPrice !== EXPECTED_COMPARE_AT) return false;
      if (!variant.mediaId || !variant.imageUrl) return false;
      if (groupMedia.has(variant.group) && String(groupMedia.get(variant.group)) !== String(variant.mediaId)) return false;
      groupMedia.set(variant.group, variant.mediaId);
      keys.add(variant.group + '|' + variant.size);
      ids.add(String(variant.id));
    }
    return keys.size === 14 && ids.size === 14 && groupMedia.size === 7;
  }

  function galleryMediaKey(sectionId, mediaId) {
    return String(sectionId || '') + '-' + String(mediaId || '');
  }

  function activateGallery(root, variant) {
    if (!variant || !variant.mediaId || typeof document === 'undefined') return false;
    var sectionId = root.dataset.sectionId || '';
    var gallery = document.getElementById('MediaGallery-' + sectionId) || document.querySelector('media-gallery');
    var mediaKey = galleryMediaKey(sectionId, variant.mediaId);
    if (!gallery || !sectionId) return false;
    try {
      var galleryThumb = gallery.querySelector('[data-target="' + mediaKey + '"]');
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaKey, true);
        if (galleryThumb) {
          setTimeout(function () { galleryThumb.click(); }, 120);
        }
        root.dataset.galleryMedia = mediaKey;
        return true;
      }
      if (galleryThumb) {
        galleryThumb.click();
        root.dataset.galleryMedia = mediaKey;
        return true;
      }
    } catch (_error) {}
    return false;
  }

  function selectedSize(root) {
    var input = root.querySelector('[data-size-input]:checked');
    return input ? input.value : '';
  }

  function ensureStickyPurchase(root) {
    if (!root || typeof document === 'undefined' || document.querySelector('[data-dryskip-sticky-purchase]')) return;
    var submit = root.querySelector('[data-dsb-submit]');
    var target = root.querySelector('[data-dsb-picker]') || root;
    if (!submit || !target) return;
    var wrapper = document.createElement('aside');
    wrapper.hidden = true;
    wrapper.setAttribute('data-dryskip-sticky-purchase', '');
    wrapper.setAttribute('aria-label', 'Voltar para a compra');
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'COMPRAR AGORA';
    wrapper.appendChild(button);
    document.body.appendChild(wrapper);

    function refresh() {
      var rect = submit.getBoundingClientRect();
      var passed = rect.bottom < 0;
      wrapper.hidden = !passed;
      wrapper.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }
    button.addEventListener('click', function () {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(function () {
        var focusTarget = root.querySelector('[data-dsb-trigger]') || submit;
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      }, reduced ? 0 : 450);
    });
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  }

  function init(root) {
    if (!root || root.dataset.dsbReady === 'true') return;
    var payload = root.querySelector('[data-dsb-variants]');
    var groupSelect = root.querySelector('[data-group-select]');
    var idInput = root.querySelector('[data-dsb-variant-id]');
    var propertyInput = root.querySelector('[data-dsb-property-group]');
    var submit = root.querySelector('[data-dsb-submit]');
    var error = root.querySelector('[data-dsb-error]');
    var form = root.querySelector('[data-dsb-form]');
    var thumb = root.querySelector('[data-dsb-thumb]');
    var picker = root.querySelector('[data-dsb-picker]');
    var trigger = root.querySelector('[data-dsb-trigger]');
    var menu = root.querySelector('[data-dsb-menu]');
    var currentLabel = root.querySelector('[data-dsb-current-label]');
    var choices = Array.prototype.slice.call(root.querySelectorAll('[data-group-value]'));
    if (!payload || !groupSelect || !idInput || !propertyInput || !submit || !error || !form || !picker || !trigger || !menu || !currentLabel || choices.length !== 7) return;

    var variants;
    try { variants = JSON.parse(payload.textContent || '[]'); } catch (_error) { variants = []; }
    if (!validMatrix(variants)) {
      idInput.value = '';
      idInput.disabled = true;
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      error.hidden = false;
      return;
    }

    var activeVariant = null;
    function setPickerOpen(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
      root.dataset.pickerOpen = open ? 'true' : 'false';
    }

    function sync(shouldActivateGallery, showError) {
      var group = groupSelect.value;
      var size = selectedSize(root);
      activeVariant = resolveVariant(variants, group, size);
      idInput.value = activeVariant ? activeVariant.id : '';
      idInput.disabled = !activeVariant;
      var option = groupSelect.options[groupSelect.selectedIndex];
      propertyInput.value = group && option ? option.textContent.trim() : '';
      currentLabel.textContent = propertyInput.value || 'Estampa';
      trigger.dataset.hasSelection = activeVariant ? 'true' : 'false';
      choices.forEach(function (choice) {
        choice.setAttribute('aria-selected', choice.dataset.groupValue === group ? 'true' : 'false');
      });
      submit.disabled = !activeVariant;
      submit.setAttribute('aria-disabled', activeVariant ? 'false' : 'true');
      error.hidden = !!activeVariant || !showError;
      root.dataset.selectedGroup = group;
      root.dataset.selectedSize = size;
      if (thumb) thumb.hidden = !activeVariant;
      if (activeVariant && thumb) {
        thumb.removeAttribute('srcset');
        thumb.removeAttribute('sizes');
        thumb.src = activeVariant.imageUrl;
        thumb.alt = propertyInput.value;
      }
      if (activeVariant && shouldActivateGallery) activateGallery(root, activeVariant);
      return !!activeVariant;
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-group-select]')) sync(true, true);
      if (event.target.matches('[data-size-input]')) sync(false, !!groupSelect.value);
    });
    trigger.addEventListener('click', function () {
      setPickerOpen(trigger.getAttribute('aria-expanded') !== 'true');
    });
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var choiceImage = choice.querySelector('img');
        if (thumb && choiceImage) {
          thumb.removeAttribute('srcset');
          thumb.removeAttribute('sizes');
          thumb.src = choiceImage.currentSrc || choiceImage.src;
          thumb.alt = choice.dataset.groupLabel || choice.textContent.trim();
          thumb.hidden = false;
        }
        groupSelect.value = choice.dataset.groupValue;
        groupSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setPickerOpen(false);
        trigger.focus();
      });
    });
    picker.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setPickerOpen(false);
        trigger.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!picker.contains(event.target)) setPickerOpen(false);
    });
    var submitLabel = submit.textContent;
    var isSubmitting = false;
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var current = resolveVariant(variants, groupSelect.value, selectedSize(root));
      if (!current || !activeVariant || String(current.id) !== String(idInput.value) || idInput.disabled) {
        sync(false, true);
        return;
      }
      if (isSubmitting) return;

      isSubmitting = true;
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'ADICIONANDO...';
      error.hidden = true;

      try {
        var cart = document.querySelector('cart-drawer');
        await removeLegacyEbookLines(cart);
        var payloadBody = {
          items: [
            {
              id: current.id,
              quantity: 1,
              properties: {
                'Estampa': propertyInput.value,
                '_bundle_role': 'parent',
                '_dryskip_ebook_bonus': 'true'
              }
            }
          ]
        };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          payloadBody.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
          payloadBody.sections_url = window.location.pathname;
        }
        var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
        var response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: JSON.stringify(payloadBody)
        });
        var result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Não foi possível adicionar ao carrinho.');

        if (cart && typeof cart.renderContents === 'function' && result.sections) {
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(submit);
          cart.classList.remove('is-empty');
          cart.renderContents(result);
          cart.classList.remove('is-empty');
          setTimeout(localizeCartDrawer, 0);
          setTimeout(localizeCartDrawer, 120);
        } else {
          window.location.assign(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');
          return;
        }
      } catch (addError) {
        error.textContent = addError && addError.message ? addError.message : 'Não foi possível adicionar ao carrinho. Tente novamente.';
        error.hidden = false;
      } finally {
        isSubmitting = false;
        submit.removeAttribute('aria-busy');
        submit.textContent = submitLabel;
        sync(false, !error.hidden);
      }
    });
    sync(false, false);
    ensureStickyPurchase(root);
    root.dataset.dsbReady = 'true';
  }

  function initAll(scope) {
    if (!scope || !scope.querySelectorAll) return;
    ensureUprightTitleStyles(scope);
    scope.querySelectorAll('[data-dryskip-bundle]').forEach(init);
  }

  var api = { resolveVariant: resolveVariant, validMatrix: validMatrix, galleryMediaKey: galleryMediaKey, activateGallery: activateGallery, validateCheckoutCart: validateCheckoutCart, init: init, initAll: initAll };
  if (typeof window !== 'undefined') window.DrySkipBundleV3 = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); watchCartDrawer(); });
    else { initAll(document); watchCartDrawer(); }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); watchCartDrawer(); });
  }
})();
